import { useEffect } from "react";
import Dropdown from "@/components/Dropdown/index";
import PropTypes from 'prop-types';

const parseJson = (value) => {
	if (typeof value === "string") {
		try {
			return JSON.parse(value);
		} catch (e) {
			return value;
		}
	}
	return value;
};

const CellDropdownComponent = ({
    isReadOnly,
    schema,
    payload,
    parentProps,
    inputProps,
    setInputProps,
    updatePayload,
    validateSchema,
    getFieldValue,
}) => {
    const options = () => {
        if (schema["x-uioptions"]) {
			const value = parseJson(schema["x-uioptions"]);

            return value.map((v, index) => {
                return { value: v.value, label: v.label, index: index }
            })
        }
        return [];
    }

    useEffect(() => {
        setInputProps({
            ...inputProps,
            disabled: isReadOnly,
            value: getFieldValue(payload, parentProps)
        });
    }, [payload]);

    const hasValue = inputProps?.value !== null && inputProps?.value !== undefined && inputProps?.value !== "";

    function onClick(value, label) {
        if (isReadOnly) {
            return;
        }
        setInputProps({ ...inputProps, value, label });
        updatePayload(value);
        validateSchema(value);
    }

    function onClear(e) {
        e.stopPropagation();
        if (isReadOnly) {
            return;
        }
        setInputProps({ ...inputProps, value: null, label: "" });
        updatePayload(null);
        validateSchema(null);
    }

    return (
        <div className="eform-dropdown-container">
            <Dropdown placeholder={isReadOnly ? null : "Select Option"} value={options().find((option) =>
                    option.value === inputProps?.value
            )?.label} disabled={isReadOnly}>
                {options().map(({ label, value, index }) => {
                    return (
                        <Dropdown.Item key={index}
                            id={label}
                            onClick={() => {
                                onClick(value, label)
                            }}
                            value
                        >
                            {label}
                        </Dropdown.Item>
                    );
                })}
            </Dropdown>
            {hasValue && !isReadOnly && (
                <span
                    className="eform-dropdown-clear"
                    data-testid="eform-dropdown-clear"
                    onClick={onClear}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && onClear(e)}
                >
                    &#x2715;
                </span>
            )}
        </div>
    );
};

CellDropdownComponent.propTypes = {
    isReadOnly: PropTypes.any,
    schema: PropTypes.any,
    payload: PropTypes.any,
    parentProps: PropTypes.any,
    inputProps: PropTypes.any,
    setInputProps: PropTypes.any,
    updatePayload: PropTypes.any,
    validateSchema: PropTypes.any,
    getFieldValue: PropTypes.any,
};

parseJson.propTypes = {
	value: PropTypes.any,
};

export default CellDropdownComponent;
